import { request as getAllBanners } from '../../../modules/banners/actions/get-all-banners';
import { error, finish } from '../../../modules/banners/actions/delete-banner';
import api from '../../../api';

export function request(dispatch, { bannerId }) {
    api.patch('/banners', {
        id: bannerId,
        active: false
    }).then(res => {
        dispatch(finish(res));
        dispatch(getAllBanners());
    }).catch(err => {
        dispatch(error(err));
    });
}
